import { MapPin } from "lucide-react";

export const mapsUrl = (address, geo) => {
  const q = address ? address : geo?.lat != null ? `${geo.lat},${geo.lng}` : "";
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
};

// Any address: tap to open Google Maps (opens the Maps app on phones).
export const MapLink = ({ address, geo, className = "", testid, icon = false }) => {
  if (!address && geo?.lat == null) return null;
  return (
    <a href={mapsUrl(address, geo)} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}
      data-testid={testid} className={`text-brand underline-offset-2 hover:underline ${className}`}>
      {icon && <MapPin className="inline h-3.5 w-3.5 mr-1 -mt-0.5" />}{address || `${geo.lat}, ${geo.lng}`}
    </a>
  );
};
